import { AnimatePresence, motion } from 'motion/react';
import { useBroadcast } from './hooks/useBroadcast';
import { useEffect, useMemo } from 'react';

import { Video } from './components/Video/Video';

import monyaLeft from './assets/videos/monya-left.webm';
import monyaRight from './assets/videos/monya-right.webm';

import gameLeft from './assets/videos/game-left.webm';
import gameRight from './assets/videos/game-right.webm';

import merchLeft from './assets/videos/merch-left.webm';
import merchRight from './assets/videos/merch-right.webm';

import selfieGirlLeft from './assets/videos/selfie-girl-left.webm';
import selfieGirlRight from './assets/videos/selfie-girl-right.webm';

import selfieMenLeft from './assets/videos/selfie-men-left.webm';
import selfieMenRight from './assets/videos/selfie-men-right.webm';

import attackLeft from './assets/videos/attack-left.webm';
import attackRight from './assets/videos/attack-right.webm';

function App() {
  const { currentState } = useBroadcast();

  const videosSrc = {
    S1: monyaLeft,
    S2: monyaRight,
    S3: gameLeft,
    S4: gameRight,
    S5: merchLeft,
    S6: merchRight,
    S7: selfieGirlLeft,
    S8: selfieGirlRight,
    S9: selfieMenLeft,
    S10: selfieMenRight,
    S11: attackLeft,
    S12: attackRight,
  };

  useEffect(() => {
    Object.values(videosSrc).forEach((src) => {
      let media = document.createElement('video');
      media.preload = 'auto';
      media.src = src;
    });
  }, []);

  const currentSrcVideo = useMemo(() => {
    return videosSrc[currentState];
  }, [currentState]);

  return (
    <div className="app-wrapper">
      <AnimatePresence mode="wait">
        {currentSrcVideo && (
          <motion.div
            key={currentSrcVideo}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <Video srcVideo={currentSrcVideo} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
